<template>
  <div class="container">
    <Loader v-show="registrantsLoading" />
    <h5>プロセス実績（直近6ヶ月間）</h5>
    <table class="table custom-table" v-if="!registrantsLoading">
      <tbody>
        <tr id="table-header">
          <!-- <th></th> -->
          <th style="background: none;"></th>
          <th scope="row" v-for="(field, index) in rowFields" :key="index" class="items">{{ field }}</th>
        </tr>
        <tr>
          <td>キャリア登録数</td>
          <td scope="row" v-for="(items, index) in registrantsCounts" :key="index" class="items"> {{ items.count }}</td>
        </tr>
  
        <tr>
            <th rowspan="2" style="position:relative;background: none !important;">
              <span class="breakdown">内訳</span>
                <!-- <div class="div" style="display: flex; flex-direction: column;"> -->
                  <table>
                    <tr class="hp-breakdown">
                      <td>自社HP経由</td>
                    </tr>
                    <tr class="shared-breakdown">
                      <td>他ルート経由</td>
                    </tr>
                  </table>
                <!-- </div> -->
            </th>
            <td scope="row" v-for="(items, index) in hpRegisteredCount" :key="index" class="items">{{ items.count }}</td>
        </tr>

        <tr>
          <!-- <td>他ルート経由</td> -->
          <td scope="row" v-for="(items, index) in sharedRegisteredCount" :key="index" class="items">{{ items.count }}</td>
        </tr>

        <tr>
          <td>コンタクト数</td>
          <td scope="row" v-for="(items, index) in contactedCounts" :key="index" class="items">{{ items.count }}</td>
        </tr>

        <tr>
          <td>応募数</td>
          <td scope="row" v-for="(items, index) in applicationCount" :key="index" class="items">{{ items.count }}</td>
        </tr>
        <tr>
          <td>面接数</td>
          <td scope="row" v-for="(items, index) in interviewedCount" :key="index" class="items">{{ items.count }}</td>
        </tr>
      </tbody>
    </table>
    <div class="info mt-4">
      <p>※プロセス実績の算出の定義</p>
      <ul>
        <li>キャリア登録数：当月に、自社にキャリア登録を行った人数</li>
        <li>コンタクト数：当月に、ステータスが「コンタクト済み」へ更新された人数</li>
        <li>応募数：当月に、ステータスが「選考応募有」へ更新された人数</li>
        <li>面接数：当月に、「面接実施ボタン」が押下された人数</li>
      </ul>
    </div>
    <br />
  </div>
</template>
  
  <script>
  import Api from '@/config/api';
  import ApiService from '@/service/apiService';
  import Loader from '@/components/utils/Loader.vue';
  import moment from 'moment';
    export default {
      name:"RegistrationTable",
      components: {Loader},
      data() {
        return {
          fixColumn:['登録','コンタクト','返信','応募','面接'],
          fields: ['合計'],
          registered:[],
          contacted:[],
          application:[],
          interviewed:[],
          hpRegistrants: [],
          sharedRegistrants: [],
          sharedRegistered:[],
          registrantsLoading: true,
        }
      },
      computed:{
          rowFields(){
            let startDate = moment().utc().subtract(5,'month').startOf('month').month()
            let endDate = moment().utc().month()
            let months=[]
             if(startDate >= 7){
                for(let i=startDate;i<=startDate+6;i++){
                  if(i>12){
                    months.push(`${i-12}月`);
                  }else if(i == 12){
                    continue;
                  }
                  else{
                    months.push(`${i+1}月`);
                  }
                }
            }else{
              for(let i=startDate;i<=endDate;i++){
              months.push(`${i+1}月`);
            }
            }
            let rowField = months.concat(this.fields);
            return this.reverseExceptLast(rowField);
          },
          registrantsCounts(){
            return this.reverseExceptLast(this.registered);
          },
          contactedCounts(){
            return this.reverseExceptLast(this.contacted);
          },
          applicationCount(){
            return this.reverseExceptLast(this.application);
          },
          interviewedCount(){
            return this.reverseExceptLast(this.interviewed);
          },
          hpRegisteredCount(){
            return this.reverseExceptLast(this.hpRegistrants);
          },
          sharedRegisteredCount(){
            return this.reverseExceptLast(this.sharedRegistrants);
          },
      },
      methods: {
        load() {
          const timezone = new Date().getTimezoneOffset();
          ApiService.get(Api.endpoints.MONTLY_CHART_BY_REGISTRANT_STATUS, {}, { timezone }).then(({ data }) => {
            this.registered = data.data.registrants;
            this.contacted = data.data.contacted;
            this.repliedOr = data.data.repliedOr;
            this.application = data.data.application;
            this.interviewed = data.data.interviewed;
            this.hpRegistrants = data.data.hpRegistrants;
            this.sharedRegistrants = data.data.sharedRegistrants;
            this.registrantsLoading = false;
          }).catch(({ response }) => this.parseErrorResponse(response));
          // ApiService.get(Api.endpoints.MONTLY_CHART_BY_REGISTRANT_STATUS, {}, { timezone }).then(({ data }) => {
          //   this.initial = data.data;
          //   this.hpRegistrants = data.data.hpRegistrants;
          //   this.sharedRegistrants = data.data.sharedRegistrants;
          // }).catch(({ response }) => this.parseErrorResponse(response));
        },
        percentage(x,y){
           if(x==0 || y==0){
            return 'NA';
          }
          let p = (100*x)/y;
          return p.toFixed(2);
        },
        reverseExceptLast(arr){
          const reversed = arr.slice(0,arr.length-1).reverse();
          return reversed.concat(arr[arr.length-1]);
        }
    },
      created() {
      this.load();
    },
    }
  </script>
  
  <style scoped>

  h5{
    color:#6b6a72;
    font-weight: 600;
  }

  li{
    list-style-type: none;
    margin-bottom:4px;
  }

  .custom-table {
    width: 80%;
    border-collapse: separate;
    border-spacing: 10px; /* Adjust the spacing between the boxes */
    margin:auto;
  }

  .breakdown{
    left: 30%;
    padding-bottom: 40px;
    padding-top: 40px;
    position: absolute;
    border: 1px solid gray;
    top: 0px;
    padding-right: 20px;
    padding-left: 20px;
    background: #fff;
  }

  .hp-breakdown{
    width: 110px;
    right: 0px;
    top: 0px;
    position: absolute;
  }

  .shared-breakdown{
    right: 0px;
    bottom: 0px;
    position: absolute;
  }

  .breakdown td{
    font-weight: normal;
  }
  .custom-table th,
  .custom-table td {
    /* padding: 8px; */
    text-align: center;
    color: #6b6a72;
    font-weight: 600;

  }

  .custom-table th{
    background-color:#d9ead3;
  }

  .custom-table th.items{
    border: 1px solid gray;
  }
  .custom-table .items{
    width:8%;
    text-align: center;
  }


  .custom-table th,
  .custom-table td {
    border: none; /* Remove the borders */
    width:25%;
    text-align: left;
  }

  .custom-table td {
    background-color: #ffffff; 
    border: 1px solid gray;
    border-radius: 2px; /* Add rounded corners */
  }

  </style>
  